import {
  VariationLedgerRow,
  type LedgerCollapse,
  type LedgerColumn,
} from '../../../shared/components/ledger';
import { VariationHoverCard } from './VariationHoverCard';
import type { VariationLedgerRowModel } from './toVariationRows';

interface VariationsLedgerRowProps {
  row: VariationLedgerRowModel;
  columns: readonly LedgerColumn[];
  collapse: LedgerCollapse;
  onOpen: (row: VariationLedgerRowModel) => void;
}

/**
 * One row of the org-wide variations list. No context menu: admin cancel is a
 * site and pot affordance, and this screen has never offered it.
 */
export function VariationsLedgerRow({
  row,
  columns,
  collapse,
  onOpen,
}: VariationsLedgerRowProps) {
  return (
    <VariationLedgerRow
      columns={columns}
      collapse={collapse}
      workTypeName={row.workTypeName}
      description={row.description}
      status={row.status}
      reference={row.reference}
      bookedBy={row.bookedBy}
      bookedAt={row.bookedAt}
      sitePlot={row.sitePlot}
      showValues={false}
      hoverCard={
        <VariationHoverCard row={row} onOpenDetails={() => onOpen(row)} />
      }
      onClick={() => onOpen(row)}
      data-testid={`variation-row-${row.id}`}
    />
  );
}
